export default __webpack_public_path__ + "static/media/GHSI AFS 2025.1cff70b8.pdf";